import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../store/global-context';
import AuthContext from '../../../store/auth-context';
import UploadInputContainer from './UploadInputContainer';
import { SingleSelectDropdown } from '../../Util/CustomDropdown';
import styles from './UpdateMasterData.module.css';
import axios from 'axios';
import PageHeader from '../../Util/PageHeader';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { IoCloudUpload } from "react-icons/io5";
import CustomCard from '../../Util/CustomCard';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
import { Button } from 'primereact/button';
import { MdEdit, MdDelete } from "react-icons/md";
import { Dialog } from 'primereact/dialog';
import { errorMessage } from "../../Util/errorMessage";
import { useDialogIsolation } from "../../Util/useDialogIsolation";

const UpdateMasterData = (props) => {
    const authCtx = useContext(AuthContext);
    const [listOfCompanies,setListOfCompanies] = useState([]);
    const [companyList,setCompanyList] = useState([]);
    const globalCtx = useContext(GlobalContext);
    const [selectedCompany,setSelectedCompany] = useState("");
    const [newCompanyName,setNewCompanyName] = useState("");
    const [editingCompany,setEditingCompany] = useState({});
    const [isEditCompanyDialogVisible,setIsEditCompanyDialogVisible] = useState(false);
    // RCMC-23: page behind inert while open, focus to the first field; RCMC-02: named close button
    const editDialogIsolation = useDialogIsolation(isEditCompanyDialogVisible, "Edit company details");

    useEffect(() => {
        axios.get(`/api/operations/get-companies`, {
            headers: { Authorization: "Bearer " + authCtx.authTokens.access },
          })
        .then(response => {
            setCompanyList(response.data);
            setListOfCompanies([{label:"All",value:""},...response.data.map((item) => ({label:item.company_name,value:item.id}))]);
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
            setListOfCompanies([]);
        });
    },[]);

    const addNewCompanyHolder = () => {
        axios.post(`/api/operations/get-companies`,{company_name:newCompanyName}, {
            headers: { Authorization: "Bearer " + authCtx.authTokens.access },
          })
        .then(response => {
            setCompanyList(prevState => {return [...prevState,response.data]});
            setListOfCompanies(prevState => {return [...prevState,{label:response.data.company_name,value:response.data.id}]});
            setNewCompanyName("");
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
        });
    }

    const editCompanyDetails = (company) => {
        setEditingCompany(company);
        setIsEditCompanyDialogVisible(true);
    }

    const deleteCompany = (id) => {
        axios.delete("/api/operations/get-companies/"+id,{
            headers: { Authorization: "Bearer " + authCtx.authTokens.access },
        }).then(response => {
            setCompanyList(prevState => prevState.filter(item => item.id !== id));
            setListOfCompanies(prevState => prevState.filter(item => item.value !== id));
            globalCtx.raiseAlert("Successfully deleted company!","success");
        }).catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
        });
    }

    const updateCompanyDetails = () => {
        axios.put("/api/operations/get-companies/"+editingCompany.id,{company_name:editingCompany.company_name},{
            headers: { Authorization: "Bearer " + authCtx.authTokens.access },
        }).then(response => {
            setCompanyList(prevState => prevState.map(item => item.id === editingCompany.id?response.data:item));
            setListOfCompanies(prevState => prevState.map(item => item.value === editingCompany.id?{label:response.data.company_name,value:response.data.id}:item));
            setIsEditCompanyDialogVisible(false);
            globalCtx.raiseAlert("Updated company details!","success");
        }).catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
        });
    }
    
    const companyDeleteTemplate = (company) => {
        return (
            <div style={{display:"flex", alignItems:"center"}}>
                <MdEdit className={styles["custom_button"]} style={{color:"var(--portal-primary)",marginRight:"8px"}} size={18} onClick={() => {editCompanyDetails(company)}} />
                {/* Ticket 22 (Q37): v1.2's #EC7063 icon was 2.97:1 on white, under the 3:1 a meaningful icon needs */}
                <MdDelete className={styles['custom_button']} style={{color:"var(--portal-danger)"}} size={18} onClick={() => {deleteCompany(company.id)}} />
            </div>
        )
    }


    return (
        <div style={{ padding: "10px", flex:"1", overflow: "hidden",display:"flex",flexDirection:"column"}}>
            <PageHeader title="Update Master Data" icon={<IoCloudUpload style={{marginRight:"5px"}} />}>
                <SingleSelectDropdown className="master-data-company-selector" label="Company" eleId="company-dropdown" styles={{width:"20vw"}} selectedValue={selectedCompany} setSelectedValue={setSelectedCompany} options={listOfCompanies} />
            </PageHeader>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3, 1fr)",gap:"10px",flex:1,padding:"10px",overflow:"hidden"}}>
                <UploadInputContainer listOfCompanies={listOfCompanies} company={selectedCompany} type="holdings" message="Upload holdings master .xlsx file" />
                <UploadInputContainer listOfCompanies={listOfCompanies} company={selectedCompany} type="certificate" message="Upload certificate master .xlsx file" />
                <CustomCard styles={{borderRadius:"20px"}}>
                        <div style={{fontSize:"1rem",fontWeight:"bold",padding:"10px",color:"#18283b"}}>Company List</div>
                        <div style={{display:"flex",width:"100%",paddingInline:"5px"}}>
                            <FloatLabel style={{width:"100%",marginRight:"5px"}}>
                                <InputText style={{flex:"1"}} id="company-name" value={newCompanyName} onChange={(e) => setNewCompanyName(e.target.value)} />
                                <label htmlFor="company-name">Company Name</label>
                            </FloatLabel>
                            <Button label='Add' onClick={addNewCompanyHolder} />
                        </div>
                        <DataTable value={companyList} paginator rows={10} stripedRows size="small" tableStyle={{ fontSize: "14px" }}>
                            <Column style={{ width: '80%' }} field="company_name" header="Name" sortable></Column>
                            {authCtx.user.is_superuser && <Column field='id' header="" body={companyDeleteTemplate}></Column>}
                        </DataTable>
                </CustomCard>
                
            </div>
            {isEditCompanyDialogVisible && <Dialog header="Edit company details" visible={isEditCompanyDialogVisible} onHide={() => {setIsEditCompanyDialogVisible(false)}} {...editDialogIsolation}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="company-name-edit">Company Name</label>
                        <InputText id="company-name-edit" value={editingCompany.company_name} onChange={(e) => {setEditingCompany(prevState => {return {...prevState,company_name:e.target.value}})}} />
                    </div>
                    <Button style={{backgroundColor:"var(--portal-primary)",color:"var(--portal-on-primary)",marginTop:"10px"}} onClick={updateCompanyDetails}>Update</Button>
                </div>
            </Dialog>}
        </div>
    )
}

export default UpdateMasterData;